<template>
    <section class="bg-dark pb-3 pt-5">
        <div class="container py-5">
            <div class="row align-items-center mt-2 mt-md-0 pt-md-4 py-lg-2">
                <div class="col-md-8 offset-md-2 order-md-1 text-center">
                    <h1 class="display-5 pt-2 text-light pb-0 mb-4 mb-lg-4" v-if="referralPage">
                        {{ referralPage.title }}
                    </h1>

                    <spinner v-if="loading"></spinner>
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative bg-white rounded-xxl-4 zindex-5" style="margin-top: -30px;">
        <div class="container pt-5 pb-2 mb-4 mb-md-5 pb-5" style="padding-top: 50px !important;">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-center py-5" v-if="loading">
                        <spinner></spinner>
                    </div>
                    <lawyers-we-recommend v-if="referralPage" :referral-page-id="referralPage.id" :referral-page-slug="referralPage.slug"></lawyers-we-recommend>
                </div>
            </div>
        </div>
    </section>
</template>
  
<script>
import Breadcrumb from '@/components/Breadcrumb'
import Spinner from "../components/Spinner";
// import SignupOverlay from "./Landing/SignupOverlay.vue";
import LawyersWeRecommend from "./Referral/LawyersWeRecommend.vue";
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
    components: { Breadcrumb, Spinner, LawyersWeRecommend },
    data() {
        return {
            referralPage: null,
            loading: false,
            error: null
        }
    },
    created() {
        this.clearWhitelabelConfiguration();
        if (this.loggedIn) {
            this.$router.push('/');
        }
        this.setReferrerSlug(this.$route.params.slug);
        this.fetchReferralPage();
    },
    methods: {
        ...mapActions('referral', ['setReferrerSlug']),
        ...mapActions('whitelabelConfiguration', ['clearWhitelabelConfiguration']),

        async fetchReferralPage() {
            this.loading = true;
            try {
                const slug = this.$route.params.slug;
                const response = await axios.get(window.API_BASE + `/referral-pages/slug/${slug}`);
                this.referralPage = response.data;
            } catch (error) {
                toast.error('Error fetching referral page');
                this.$router.push('/');
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        ...mapGetters('auth', {
            loggedIn: 'loggedIn'
        }),
        ...mapGetters('referral', {
            referrerSlug: 'referrerSlug'
        })
    }
}
</script>
  
<style scoped lang="scss">
.text-primary {
    color: rgb(var(--primary-colour)) !important;
}
</style>